define.alias("shared/components/shared/ui/mobile-menu", "media/components/shared/ui/mobile-menu");